var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 18,
    viewBox: "0 0 112 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5432 17.1423V9.17839L7.66267 14.9772H5.96822L3.08766 9.17839V17.1423H0V3.77498H3.35124L6.81545 10.7599L10.2985 3.77498H13.6309V17.1423H10.5432Z",
    fill: "url(#paint0_linear_1905_21857)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2033 14.1864C15.2033 13.5337 15.3853 12.9627 15.7492 12.4731C16.1132 11.9836 16.6153 11.6008 17.2554 11.3247C17.8955 11.036 18.6298 10.8917 19.4582 10.8917C19.8598 10.8917 20.2552 10.9293 20.6443 11.0046C21.0334 11.0674 21.3723 11.1615 21.661 11.287V10.854C21.661 10.3143 21.4978 9.9001 21.1715 9.61141C20.8451 9.32273 20.3494 9.17839 19.6841 9.17839C19.1319 9.17839 18.611 9.27252 18.1215 9.46079C17.6445 9.64907 17.1362 9.91892 16.5965 10.2704L15.6928 8.34999C16.3454 7.92324 17.0232 7.60318 17.7261 7.3898C18.4415 7.17643 19.1946 7.06974 19.9854 7.06974C21.4664 7.06974 22.6149 7.42746 23.4307 8.14289C24.2591 8.84577 24.6733 9.86872 24.6733 11.2117V13.7911C24.6733 14.0923 24.7173 14.3057 24.8051 14.4312C24.9055 14.5441 25.075 14.6132 25.3135 14.6383V17.1423C25.0624 17.1925 24.824 17.2302 24.598 17.2553C24.3847 17.2804 24.1964 17.2929 24.0332 17.2929C23.4684 17.2929 23.0354 17.1799 22.7341 16.954C22.4455 16.7281 22.2635 16.4206 22.1881 16.0315L22.1317 15.5985C21.6924 16.1633 21.1652 16.5963 20.5502 16.8975C19.9477 17.1862 19.3139 17.3306 18.6486 17.3306C17.996 17.3306 17.406 17.1925 16.8789 16.9164C16.3643 16.6402 15.9563 16.2637 15.6551 15.7867C15.3539 15.3098 15.2033 14.7763 15.2033 14.1864ZM21.1903 14.563C21.3284 14.45 21.4413 14.3245 21.5292 14.1864C21.6171 14.0484 21.661 13.9166 21.661 13.7911V12.9062C21.41 12.8058 21.1275 12.7305 20.8138 12.6802C20.5125 12.6175 20.2301 12.5861 19.9665 12.5861C19.4143 12.5861 18.9561 12.7116 18.5922 12.9627C18.2282 13.2011 18.0462 13.5212 18.0462 13.9228C18.0462 14.1488 18.1089 14.3559 18.2344 14.5441C18.36 14.7324 18.5294 14.883 18.7428 14.996C18.9687 15.109 19.2323 15.1654 19.5335 15.1654C19.8347 15.1654 20.136 15.109 20.4372 14.996C20.7385 14.883 20.9895 14.7387 21.1903 14.563Z",
    fill: "url(#paint1_linear_1905_21857)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1256 9.83734C32.3976 9.83734 31.7386 9.95658 31.1487 10.1951C30.5588 10.421 30.132 10.7599 29.8685 11.2117V17.1423H26.8561V7.25801H29.6237V9.2537C29.9626 8.58847 30.4019 8.06758 30.9416 7.69104C31.4813 7.31449 32.0461 7.11995 32.6361 7.10739C32.7741 7.10739 32.8745 7.10739 32.9373 7.10739C33.0126 7.10739 33.0754 7.11367 33.1256 7.12622V9.83734Z",
    fill: "url(#paint2_linear_1905_21857)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0403 17.1423L38.461 13.1886L37.4067 14.2617V17.1423H34.3943V3.39844H37.4067V11.3435L40.7579 7.25801H43.9397L40.3814 11.513L44.241 17.1423H41.0403Z",
    fill: "url(#paint3_linear_1905_21857)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3426 17.3306C48.5016 17.3306 47.7548 17.1988 47.1021 16.9352C46.4494 16.6591 45.8909 16.2888 45.4265 15.8244C44.9746 15.36 44.6295 14.8265 44.391 14.2241C44.1525 13.6091 44.0333 12.9689 44.0333 12.3037C44.0333 11.3498 44.2404 10.4837 44.6546 9.70555C45.0813 8.91481 45.6901 8.28096 46.4808 7.804C47.2716 7.31449 48.2255 7.06974 49.3426 7.06974C50.4596 7.06974 51.4073 7.30822 52.1855 7.78517C52.9762 8.26213 53.5787 8.8897 53.9929 9.66789C54.4071 10.4335 54.6142 11.2682 54.6142 12.1719C54.6142 12.3476 54.6016 12.5234 54.5765 12.6991C54.564 12.8622 54.5514 13.0066 54.5389 13.1321H47.2339C47.2716 13.5714 47.3908 13.9417 47.5916 14.2429C47.805 14.5441 48.0749 14.7763 48.4012 14.9395C48.7275 15.0901 49.0727 15.1654 49.4367 15.1654C49.8885 15.1654 50.309 15.0587 50.6981 14.8454C51.0998 14.632 51.3759 14.3433 51.5265 13.9793L54.087 14.6948C53.836 15.2094 53.4783 15.6675 53.0139 16.0691C52.562 16.4582 52.0223 16.7657 51.3947 16.9917C50.7797 17.2176 50.0956 17.3306 49.3426 17.3306ZM47.1586 11.287H51.4512C51.401 10.8728 51.2818 10.5151 51.0935 10.2139C50.9052 9.9001 50.6542 9.66162 50.3404 9.49845C50.0266 9.32273 49.6814 9.23487 49.3049 9.23487C48.9158 9.23487 48.5644 9.32273 48.2506 9.49845C47.9493 9.66162 47.7046 9.9001 47.5163 10.2139C47.328 10.5151 47.2088 10.8728 47.1586 11.287Z",
    fill: "url(#paint4_linear_1905_21857)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2704 16.6151C61.9942 16.7281 61.6867 16.8411 61.3478 16.954C61.0215 17.067 60.6763 17.1548 60.3123 17.2176C59.9483 17.2929 59.5906 17.3306 59.2392 17.3306C58.7371 17.3306 58.2727 17.249 57.846 17.0858C57.4318 16.9101 57.0992 16.6277 56.8481 16.2386C56.6097 15.8495 56.4904 15.3349 56.4904 14.6948V9.5361H55.229V7.25801H56.4904V4.11387H59.5028V7.25801H61.5173V9.5361H59.5028V13.6593C59.5028 13.9856 59.5844 14.2241 59.7475 14.3747C59.9107 14.5128 60.1178 14.5818 60.3688 14.5818C60.5822 14.5818 60.8081 14.5441 61.0466 14.4688C61.2976 14.3935 61.511 14.3119 61.6867 14.2241L62.2704 16.6151Z",
    fill: "url(#paint5_linear_1905_21857)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0836 14.4312V17.1423H63.6889V3.77498H72.9142V6.4861H66.7765V9.08425H72.0482V11.5883H66.7765V14.4312H73.0836Z",
    fill: "url(#paint6_linear_1905_21857)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2381 17.3306C78.3971 17.3306 77.6503 17.1925 76.9977 16.9164C76.345 16.6402 75.7864 16.2637 75.322 15.7867C74.8702 15.3098 74.525 14.7638 74.2865 14.1488C74.0481 13.5337 73.9288 12.8811 73.9288 12.1907C73.9288 11.287 74.1359 10.4461 74.5501 9.66789C74.9769 8.8897 75.5856 8.26213 76.3764 7.78517C77.1671 7.30822 78.121 7.06974 79.2381 7.06974C80.3677 7.06974 81.3216 7.31449 82.0998 7.804C82.8906 8.28096 83.4805 8.90853 83.8696 9.68672L80.9325 10.5716C80.7443 10.2704 80.4995 10.0382 80.1983 9.87499C79.9096 9.71182 79.5833 9.63024 79.2193 9.63024C78.8051 9.63024 78.4285 9.73693 78.0896 9.9503C77.7633 10.1637 77.4997 10.4586 77.2989 10.8352C77.1106 11.2117 77.0165 11.6636 77.0165 12.1907C77.0165 12.7053 77.1169 13.1572 77.3177 13.5463C77.5185 13.9354 77.7821 14.2429 78.1085 14.4688C78.4348 14.6822 78.8051 14.7889 79.2193 14.7889C79.4703 14.7889 79.7025 14.7512 79.9159 14.6759C80.1418 14.5881 80.3426 14.4688 80.5183 14.3182C80.7066 14.1676 80.8509 13.9981 80.9514 13.8099L83.8884 14.7136C83.6499 15.2156 83.3048 15.6675 82.8529 16.0691C82.4136 16.4582 81.8927 16.7657 81.2903 16.9917C80.6878 17.2176 80.0037 17.3306 79.2381 17.3306Z",
    fill: "url(#paint7_linear_1905_21857)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7764 17.1423H91.7641V11.5883C91.7641 10.9481 91.6323 10.4775 91.3687 10.1762C91.1177 9.87499 90.7788 9.72438 90.352 9.72438C90.1261 9.72438 89.8688 9.79968 89.5801 9.9503C89.304 10.0884 89.0467 10.2892 88.8082 10.5528C88.5697 10.8164 88.3877 11.1239 88.2622 11.4753V17.1423H85.2498V3.39844H88.2622V8.91481C88.6262 8.32489 89.1031 7.87303 89.6931 7.55925C90.2955 7.23291 90.9545 7.06974 91.6699 7.06974C92.3477 7.06974 92.8874 7.1827 93.2891 7.40863C93.7033 7.63456 94.017 7.93579 94.2304 8.31234C94.4438 8.67633 94.5881 9.07798 94.6634 9.51728C94.7388 9.95658 94.7764 10.3896 94.7764 10.8164V17.1423Z",
    fill: "url(#paint8_linear_1905_21857)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.485 17.3306C100.644 17.3306 99.8906 17.1925 99.2254 16.9164C98.5727 16.6402 98.0204 16.2637 97.5686 15.7867C97.1167 15.3098 96.7716 14.7638 96.5331 14.1488C96.3071 13.5337 96.1942 12.8873 96.1942 12.2096C96.1942 11.5192 96.3071 10.8666 96.5331 10.2515C96.7716 9.63652 97.1167 9.09053 97.5686 8.61357C98.0204 8.13662 98.5727 7.76007 99.2254 7.48394C99.8906 7.20781 100.644 7.06974 101.485 7.06974C102.326 7.06974 103.072 7.20781 103.725 7.48394C104.378 7.76007 104.93 8.13662 105.382 8.61357C105.834 9.09053 106.179 9.63652 106.417 10.2515C106.656 10.8666 106.775 11.5192 106.775 12.2096C106.775 12.8873 106.656 13.5337 106.417 14.1488C106.179 14.7638 105.834 15.3098 105.382 15.7867C104.93 16.2637 104.378 16.6402 103.725 16.9164C103.072 17.1925 102.326 17.3306 101.485 17.3306ZM99.2818 12.2096C99.2818 12.7242 99.376 13.176 99.5643 13.5651C99.7651 13.9542 100.029 14.2555 100.355 14.4688C100.681 14.6822 101.058 14.7889 101.485 14.7889C101.899 14.7889 102.269 14.6822 102.595 14.4688C102.934 14.2429 103.198 13.9354 103.386 13.5463C103.574 13.1572 103.669 12.7116 103.669 12.2096C103.669 11.695 103.574 11.2431 103.386 10.854C103.198 10.4649 102.934 10.1637 102.595 9.9503C102.269 9.73693 101.899 9.63024 101.485 9.63024C101.058 9.63024 100.681 9.73693 100.355 9.9503C100.029 10.1637 99.7651 10.4649 99.5643 10.854C99.376 11.2431 99.2818 11.695 99.2818 12.2096Z",
    fill: "url(#paint9_linear_1905_21857)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.818 2.55069V0.667969H111.84V9.61089H109.957V2.55069H102.818Z",
    fill: "url(#paint10_linear_1905_21857)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1905_21857",
    x1: 0.00000173341,
    y1: 10,
    x2: 113.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1905_21857",
    x1: 0.00000173341,
    y1: 10,
    x2: 113.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1905_21857",
    x1: 0.00000173341,
    y1: 10,
    x2: 113.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1905_21857",
    x1: 0.00000173341,
    y1: 10,
    x2: 113.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1905_21857",
    x1: 0.00000173341,
    y1: 10,
    x2: 113.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1905_21857",
    x1: 0.00000173341,
    y1: 10,
    x2: 113.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1905_21857",
    x1: 0.00000173341,
    y1: 10,
    x2: 113.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1905_21857",
    x1: 0.00000173341,
    y1: 10,
    x2: 113.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1905_21857",
    x1: 0.00000173341,
    y1: 10,
    x2: 113.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1905_21857",
    x1: 0.00000173341,
    y1: 10,
    x2: 113.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1905_21857",
    x1: -0.00013394,
    y1: 0.999998,
    x2: 109.902,
    y2: -24.8867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/whiteLogo.7e097da15830812dbfaac4f533583ebc.svg";
export { ForwardRef as ReactComponent };